import logo from './logo.svg';
import './App.css';

import Banner from './components/Banner';
import About from './components/About';
import Counter from './components/Counter';
import Award from './components/Award';
import Qualification from './components/Qualification';
import Skills from './components/Skills';
import ContactForm from './components/Contact';
import Works from './components/Works';

function App() {
  return (
    <div>
      <Banner />
      <About />
      <Counter/>
      <Award/>
      <Qualification />
      <Works/>
      <Skills/>
      <ContactForm/>
    
    </div>
  );
}

export default App;
